import script from "./attractCard.vue?vue&type=script&setup=true&lang=js"
export * from "./attractCard.vue?vue&type=script&setup=true&lang=js"

import "./attractCard.vue?vue&type=style&index=0&id=125406f8&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125406f8"]])

export default __exports__